import { cn } from "../utils";

interface DecorativeBlobProps {
  /** Blob color variant */
  variant?: "primary" | "secondary" | "accent";
  /** Blob size */
  size?: "sm" | "md" | "lg" | "xl";
  /** Position classNames (e.g., "top-10 left-20") */
  position?: string;
  /** Animation type */
  animation?: "float" | "pulse-glow" | "spin-slow" | "none";
  /** Custom className */
  className?: string;
}

const sizeClasses = {
  sm: "w-32 h-32",
  md: "w-48 h-48",
  lg: "w-64 h-64",
  xl: "w-96 h-96",
};

const variantClasses = {
  primary: "bg-primary/10",
  secondary: "bg-secondary/10",
  accent: "bg-accent/10",
};

const animationClasses = {
  float: "animate-float",
  "pulse-glow": "animate-pulse-glow",
  "spin-slow": "animate-spin-slow",
  none: "",
};

/**
 * Decorative floating blob for adding visual interest to backgrounds
 */
export function DecorativeBlob({
  variant = "primary",
  size = "lg",
  position = "top-20 right-10",
  animation = "pulse-glow",
  className,
}: DecorativeBlobProps) {
  return (
    <div
      className={cn(
        "absolute rounded-full blur-3xl pointer-events-none",
        sizeClasses[size],
        variantClasses[variant],
        animationClasses[animation],
        position,
        className
      )}
      aria-hidden="true"
    />
  );
}
